import React from "react"
import clsx from "clsx"
import { Link } from "gatsby"
import { getMenuLink, gtagReportConversion } from "@lib/utils"
import ArrowUpRightIcon from "@components/icons/ArrowUpRightIcon"
import MobileIcon from "@components/icons/MobileIcon"
import SearchIcon from "@components/icons/SearchIcon"
import loadable from "@loadable/component"
import { ENQUIRY_FORMS } from "@components/forms/utils"

const CTALink = ({ onClick, className, cta, children, alsoLabel, file, istrackSpot, reload }) => {
  if (!cta) return null

  const { cta_label, custom_link, menu, isExternal, icon } = cta

  let linkHref = null

  linkHref = menu && getMenuLink(menu)

  let FormPopup = null
  if (menu?.link_type === "popup") {
    if (menu.slug === "off-market-popup") {
      FormPopup = loadable(() =>
        import("@components/OffMarketFormModal/OffMarketFormModal")
      )
    } else if (menu.slug === "download-report") {
      FormPopup = loadable(() =>
        import("@components/DownloadReportModal/DownloadReportModal")
      )
    } else if (
      menu.slug === ENQUIRY_FORMS.generalEnquiry ||
      menu.slug === ENQUIRY_FORMS.partnerProgram ||
      menu.slug === ENQUIRY_FORMS.propertyMangement ||
      menu.slug === ENQUIRY_FORMS.shortTerm ||
      menu.slug === ENQUIRY_FORMS.mortagage ||
      menu.slug === ENQUIRY_FORMS.snagging ||
      menu.slug === ENQUIRY_FORMS.prismPopup ||
      menu.slug === ENQUIRY_FORMS.propertyLeasing ||
      menu.slug === ENQUIRY_FORMS.conveyancingPopup ||
      menu.slug === ENQUIRY_FORMS.primestay ||
      menu.slug === ENQUIRY_FORMS.ifxCalculatorPopup
    ) {
      FormPopup = loadable(() =>
        import("@components/EnquiryModal/EnquiryModal")
      )
    }
  }
  if (FormPopup) {
    return (
      <FormPopup
        noScrollOnSuccess
        triggerClassName={className}
        choose_form={menu?.slug}
        file={file?.url}
      >
        {children || <span>{cta_label}</span>}
        {/* {Icon || ""} */}
      </FormPopup>
    )
  }

  if (custom_link) {
    if (isExternal) {
      linkHref = { href: custom_link }
    } else {
      linkHref = { to: custom_link }
    }
  }

  let Icon
  switch (icon) {
    case "up-right-arrow-white":
      Icon = <ArrowUpRightIcon color="white" />
      break
    case "phone-blue":
      Icon = <MobileIcon />
      break
    case "search-blue":
      Icon = <SearchIcon />
      break

    default:
      break
  }

  if (!(linkHref?.to || linkHref?.href || custom_link)) {
    if (alsoLabel) {
      return (
        <button className={clsx(className)}>
          <span>{cta_label}</span>
          {Icon || ""}
        </button>
      )
    }

    return null
  }

  const Comp = reload || custom_link?.includes("tel:") || istrackSpot ? "a" : Link

  if (Comp === "a" && linkHref?.to) {
    linkHref.href = linkHref?.to
  }

  return (
    <Comp
      className={clsx(className)}
      onClick={() => {
        if (onClick) {
          onClick()
        }
        if (custom_link?.includes("tel:")) {
          gtagReportConversion(custom_link)
        }
      }}
      {...linkHref}
      {...(!reload && (!!isExternal || (!!custom_link?.includes("http") && !custom_link?.includes("#"))) && {
        target: "_blank",
      })}
    >
      {children || (
        <>
          <span>{cta_label}</span>
          {Icon || ""}
        </>
      )}
    </Comp>
  )
}

export default CTALink
